import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Style } from 'src/common/common.interface'

export interface StyleState {
  styles?: Style[]
  countStyle: number
  isLoadingGetStyles: boolean
}

const initialState: StyleState = {
  styles: undefined,
  countStyle: 0,
  isLoadingGetStyles: false
}

const styleSlice = createSlice({
  name: 'style',
  initialState,
  reducers: {
    setStylesData(state, action: PayloadAction<Style[]>) {
      state.styles = action.payload
    },
    setCountStyles(state, action: PayloadAction<number>) {
      state.countStyle = action.payload
    },
    setIsLoadingGetStyles(state, action: PayloadAction<boolean>) {
      state.isLoadingGetStyles = action.payload
    }
  }
})

export const styleAction = styleSlice.actions

export default styleSlice.reducer
